import { useId } from 'react';
import { formatEventDate, TextField } from '../components';

type Change = { target: { value: string } };

/** A from–to pair of date inputs under one label, for list filters. Values are YYYY-MM-DD or ''. */
export function DateRange({
  label,
  from,
  to,
  onFrom,
  onTo,
}: {
  label: string;
  from: string;
  to: string;
  onFrom: (value: string) => void;
  onTo: (value: string) => void;
}) {
  const id = useId();
  return (
    <div className="rq-daterange" role="group" aria-labelledby={id}>
      <span className="rq-daterange-label" id={id}>
        {label}
      </span>
      <TextField
        label="From"
        hideLabel
        type="date"
        value={from}
        max={to || undefined}
        onChange={(e: Change) => onFrom(e.target.value)}
      />
      <span className="rq-daterange-sep" aria-hidden="true">
        –
      </span>
      <TextField
        label="To"
        hideLabel
        type="date"
        value={to}
        min={from || undefined}
        onChange={(e: Change) => onTo(e.target.value)}
      />
    </div>
  );
}

/** "1 Oct 2026 – 31 Dec 2026", "From 1 Oct 2026", "Until 31 Dec 2026", for a filter chip. */
export function dateRangeLabel(from: string | undefined, to: string | undefined): string {
  const day = (d: string) => formatEventDate(d, null, { weekday: false }).date;
  if (from && to) return `${day(from)} – ${day(to)}`;
  if (from) return `From ${day(from)}`;
  return to ? `Until ${day(to)}` : '';
}
